<template>
  <div class="overflow-hidden w-full px-4">
    <div class="flex items-center justify-between pb-4">
      <h1 class="py-2 text-zt-xl text-zt-primary-200 font-normal">
        {{ $t('message.searchComponent.sectionName') }}
      </h1>
    </div>
    <div class="main--container pr-6">
      <div
        :class="{ 'main--content__open': isSearchListVisible }"
        class="main--content max-h-full"
      >
        <SearchList ref="SearchListComponent" v-show="isSearchListVisible" />
        <SearchTable @reload-table="reload" />
      </div>
    </div>
  </div>
</template>

<script>
import SearchList from '@/components/DocumentSearch/SearchList.vue'
import SearchTable from '@/components/DocumentSearch/SearchTable.vue'
import { mutations, store } from '@/components/DocumentSearch/store'
import { has, isEmpty, isObject } from 'lodash'
import bus from '@/bus'

const statusEmployee = {
  pending: 'NO FIRMADO',
  signed: 'FIRMADO CONFORME',
  signed_agreement: 'FIRMADO CONFORME',
  signed_disagreement: 'FIRMADO DISCONFORME'
}

const existHistoryProperty = (property) => {
  const { history: { params } } = store
  return has(params, property)
}

export default {
  name: 'SearchDocumentsPage',
  provide: {
    store,
    ...mutations,
    existHistoryProperty
  },
  components: {
    SearchList,
    SearchTable,
  },
  computed: {
    isSearchListVisible() {
      return store.searchListVisible
    },
    isManPower() {
      return this.$store.state.user.empresa.id === 135
    }
  },
  methods: {
    ...mutations,
    reload(reloaded) {
      if (reloaded) {
        this.$refs.SearchListComponent.searchDocuments();
      }
    }
  },
  async created() {
    this.setFilters({})
    this.setInitialStatus(true)
    let history = {}
    const queryParamFromDashboard = this.$route.query.status
    if (queryParamFromDashboard) {
      history = {
        orderBy: 'id',
        orderType: 'desc',
        pagination: { rows: 20, page: 1 },
        params: {
          signStatus: [statusEmployee[queryParamFromDashboard]]
        }
      }
    } else {
      history = this.$store.getters.getSearchDocumentRRHH
    }

    if (!isEmpty(history)) {
      await this.setHistory(history)
      const params = { ...history.params }
      Object.keys(params).forEach((key) => {
        if (Array.isArray(params[key])) {
          params[key] = params[key].map(item => {
            if (isObject(item)) {
              return item.id
            }
            return item
          })
        }
      })
      if (
        existHistoryProperty('subFolderId') &&
        existHistoryProperty('subFolderId_two')
      ) {
        params.subFolderId = [
          ...new Set([
              ...history.params.subFolderId,
              ...history.params.subFolderId_two.map(e => e.id)
            ]
          )
        ]
        delete params.subFolderId_two
      }
      if (
        !existHistoryProperty('subFolderId') &&
        existHistoryProperty('subFolderId_two')) {
        params.subFolderId = history.params.subFolderId_two.map(e => e.id)
        delete params.subFolderId_two
      }
      if (existHistoryProperty('eformSingle') && existHistoryProperty('eform')) {
        params.eform = [...new Set([...params.eform, ...params.eformSingle])]
        delete params.eformSingle
      }
      if (existHistoryProperty('eformSingle') && !existHistoryProperty('eform')) {
        params.eform = params.eformSingle
        delete params.eformSingle
      }
      await this.setFilters(params)
      this.setOrderBy(history.orderBy)
      this.setOrderType(history.orderType)
      this.setPagination(history.pagination)

      this.$refs.SearchListComponent.searchDocuments()
    } else {
      this.setHistory({})
    }
    bus.$on("userchange", () => {
      this.$store.dispatch('setSearchDocumentRRHH', { documentSearch: {} })
      this.setHistory({})
      this.setInitialStatus(true)
    });
  }
}
</script>

<style scoped>
.main--container {
  max-height: calc(100vh - 74px - 32px - 40px);
}

.main--content {
  display: grid;

  column-gap: 24px;
}

.main--content__open {
  grid-template-columns: 25% 75%;
}

.main--content__close {
  grid-template-columns: 1fr;
}
</style>
